(function () {
  'use strict';

  let variants = [];
  let currentIndex = 0;

  function loadVariants() {
    const dataEl = document.querySelector('[data-ot-variants]');
    if (!dataEl) return false;
    try {
      variants = JSON.parse(dataEl.textContent);
      return true;
    } catch (e) {
      return false;
    }
  }

  function getKachingBars() {
    const bars = document.querySelectorAll(
      '.kaching-bundles__bars .kaching-bundles__bar, ' +
      '.kaching-bundles__deal-bars .kaching-bundles__bar'
    );
    return bars.length
      ? Array.from(bars)
      : Array.from(document.querySelectorAll('.kaching-bundles__bar')).filter(
          (el) => el.getAttribute('role') !== 'checkbox'
        );
  }

  function getSelectedBarIndex() {
    const bars = getKachingBars();
    for (let i = 0; i < bars.length; i++) {
      if (bars[i].classList.contains('kaching-bundles__bar--selected')) {
        return i;
      }
    }
    return -1;
  }

  function updateOneTimePriceDisplay() {
    const priceEl = document.querySelector('[data-ot-price]');
    if (!priceEl) return;
    const variant = variants[currentIndex];
    if (!variant) return;
    priceEl.textContent = variant.priceFormatted;
  }

  function updateSubPriceDisplay() {
    const subEl = document.querySelector('[data-ot-sub-price]');
    if (!subEl) return;

    const bars = getKachingBars();
    const selectedBar = bars[currentIndex];
    if (!selectedBar) return;

    const priceNode = selectedBar.querySelector('.kaching-bundles__bar-price');
    if (priceNode) {
      subEl.textContent = priceNode.textContent.trim();
    }
  }

  function syncToKaching() {
    const idx = getSelectedBarIndex();
    if (idx === -1) return;

    if (idx >= variants.length) {
      currentIndex = variants.length - 1;
    } else {
      currentIndex = idx;
    }

    updateOneTimePriceDisplay();
    updateSubPriceDisplay();
  }

  function setButtonLoading(loading) {
    const btn = document.querySelector('[data-ot-trigger]');
    if (!btn) return;
    btn.disabled = loading;
  }

  function openCart() {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
    } else {
      document.dispatchEvent(new CustomEvent('theme:cart:open'));
    }
  }

  function addToCart() {
    const variant = variants[currentIndex];
    if (!variant) return;

    setButtonLoading(true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variant.id, quantity: 1 }],
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status || data.errors) return;
        openCart();
      })
      .catch(() => {})
      .finally(() => {
        setButtonLoading(false);
      });
  }

  function observeBarChanges() {
    const bundleBlock = document.querySelector('kaching-bundles-block');
    if (!bundleBlock) {
      setTimeout(observeBarChanges, 500);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some(
        (m) =>
          m.type === 'attributes' &&
          m.attributeName === 'class' &&
          m.target.classList &&
          m.target.classList.contains('kaching-bundles__bar') &&
          m.target.getAttribute('role') !== 'checkbox'
      );
      if (relevant) syncToKaching();
    });

    observer.observe(bundleBlock, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
      // Also catch text changes — Kaching may rewrite the price node
      // when the sub toggle state changes
      characterData: true,
    });
  }

  function init() {
    if (!loadVariants()) return;

    const btn = document.querySelector('[data-ot-trigger]');
    if (btn && !btn.dataset.bound) {
      btn.dataset.bound = 'true';
      btn.addEventListener('click', addToCart);
    }

    syncToKaching();
    observeBarChanges();
  }

  setTimeout(init, 500);
  document.addEventListener('kaching-bundles-block-loaded', () => setTimeout(init, 200));
})();